import React, { useState, useEffect } from 'react';
import * as Store from '@apply/store';
import DataGrid, { Column, Paging, Pager, ColumnFixing } from 'devextreme-react/data-grid';
import { alertModal } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { EditLicenseToBuildModal } from './modals/EditLicenseToBuildModal';
import LoadPanel from 'devextreme-react/load-panel';
import { BusinessAndPeopleApi } from '@apply/api';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

interface ILicenseToBuildPanelParameters {
    applicationInsights: ApplicationInsights;
    currentTopLevelBusiness: number;
}

export const LicenseToBuildPanel = ({
    applicationInsights,
    currentTopLevelBusiness,
}: ILicenseToBuildPanelParameters): JSX.Element => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(applicationInsights);
    const [selectedBusinessId, set_selectedBusinessId] = useState<number>(0);
    const [selectedBusiness, set_selectedBusiness] = useState(null);
    const [builderLicenses, set_builderLicenses] = useState([]);
    const [licenseToBuildId, set_licenseToBuildId] = useState<number>(0);

    const allowedPageSizes = [15, 25, 50];
    const defaultPageSize = allowedPageSizes[0];
    const [licenseToBuildEditorOpen, set_licenseToBuildEditorOpen] = useState(false);

    const [loadingMessage, set_loadingMessage] = useState('');
    const [loadingOpen, set_loadingOpen] = useState(false);

    const onClickEditLicenseToBuild = (event, id: number) => {
        event.preventDefault();
        event.stopPropagation();
        set_licenseToBuildId(id);
        set_licenseToBuildEditorOpen(true);
    };

    const onClickAddLicenseToBuild = async (id: number) => {
        set_licenseToBuildId(id);
        set_licenseToBuildEditorOpen(true);
    };

    const onLicenseToBuildClose = async () => {
        set_licenseToBuildEditorOpen(false);
        set_licenseToBuildId(0);
        loadBuilderLicenses();
    };

    useEffect(() => {
        loadBuilderLicenses();
    }, [selectedBusinessId]);

    useEffect(() => {
        if (selectedBusinessId != currentTopLevelBusiness) {
            set_selectedBusinessId(currentTopLevelBusiness);
        }
    }, [currentTopLevelBusiness]);

    const loadBuilderLicenses = async () => {
        // if (currentTopLevelBusiness || currentTopLevelBusiness >= 0) {
        //     try {
        //         set_loadingOpen(true);
        //         set_loadingMessage('Loading...');
        //         const response = await businessAndPeopleApi.getBuilderLicenses(currentTopLevelBusiness);
        //         if (response.statusCode !== 200) {
        //             alertModal({
        //                 message: 'Failed to load Builder Licenses. Please try again.',
        //             });
        //         }
        //         set_builderLicenses(response.result);
        //     } catch (ex) {
        //         set_builderLicenses([]);
        //         alertModal({
        //             message: 'Failed to load Builder Licenses. Please try again.',
        //         });
        //     } finally {
        //         set_loadingOpen(false);
        //         set_loadingMessage('');
        //     }
        // }
    };

    const onActionRender = (e) => {
        return (
            <div>
                <button
                    className='button gridActionColumnButton'
                    title='Edit License'
                    onClick={(event) => onClickEditLicenseToBuild(event, e.data.id)}
                >
                    <FontAwesomeIcon icon={faEdit} />
                </button>
            </div>
        );
    };

    return (
        <>
            <div style={{ width: '100%', display: 'inline-block' }}>
                <div style={{ width: '100%', paddingBottom: '10px' }}>
                    <button
                        className='button gridActionColumnButton'
                        onClick={(event) => {
                            onClickAddLicenseToBuild(0);
                        }}
                        style={{
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: '0',
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faEdit}
                            style={{ paddingRight: '5px' }}
                        />
                        Add License To Build
                    </button>
                </div>
                <div style={{ width: '100%' }}>
                    <DataGrid
                        keyExpr='id'
                        id='builderLicensesTable'
                        dataSource={builderLicenses}
                        showBorders={true}
                        showRowLines={true}
                        remoteOperations={false}
                        allowColumnResizing={true}
                        allowColumnReordering={false}
                        columnResizingMode={'nextColumn'}
                        columnMinWidth={20}
                        cellHintEnabled={true}
                        width={'auto'}
                        noDataText='No Licenses to Build found'
                    >
                        <ColumnFixing enabled={true} />
                        <Column
                            caption='Business'
                            dataField='businessName'
                            alignment={'left'}
                            minWidth={200}
                            allowSorting={false}
                        />
                        <Column
                            caption='Name'
                            dataField='name'
                            alignment={'left'}
                            minWidth={200}
                            allowSorting={false}
                        />
                        <Column
                            dataField='state'
                            caption='State'
                            alignment='left'
                            minWidth={40}
                            allowSorting={false}
                        />
                        <Column
                            dataField='licenseNumber'
                            caption='License Number'
                            alignment='left'
                            minWidth={40}
                            allowSorting={false}
                        />
                        <Column
                            caption='Exp. Date'
                            dataField='licenseExpirationDate'
                            alignment={'left'}
                            minWidth={40}
                            allowSorting={false}
                        />
                        <Column
                            caption=''
                            cellRender={onActionRender}
                            width={80}
                            alignment='center'
                        />
                        <Paging defaultPageSize={defaultPageSize} />
                        <Pager
                            showPageSizeSelector={allowedPageSizes.length > 1}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                            showInfo={true}
                            visible={true}
                        />
                    </DataGrid>
                </div>
            </div>
            <EditLicenseToBuildModal
                selectedBusinessId={selectedBusinessId}
                builderLicenseId={licenseToBuildId}
                isOpen={licenseToBuildEditorOpen}
                applicationInsights={applicationInsights}
                onCloseCallback={onLicenseToBuildClose}
            />
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </>
    );
};
